export default __webpack_public_path__ + "static/desk04-1eb325146af99a50aef2efb7d385b6f7.png";